import React, { Component } from "react";
import { connect } from "react-redux";
import Col from "../../../../common/grid/Col.js";
import Button from "../../../../common/button/Button.js";
import Accordion from "../../../../common/accordion/Accordion.js";
import Checkbox from "../../../../common/checkbox/Checkbox.js";

// Actions
import { fetchUsers } from "../../../../actions/user.js";
import { fetchDonors } from "../../../../actions/donor.js";
import { setErrors, clearErrors } from "../../../../actions/error.js";
import {
  fetchProject,
  updateProject,
  unsetSelectedProject
} from "../../../../actions/project.js";
import { resetAssets } from "../../../../actions/asset.js";
import {
  resetAttachments,
  deleteAttachments
} from "../../../../actions/attachment.js";

import { validate } from "../../../../helpers/validate.js";

import Assets from "../_common/Assets.js";

// Form blocks
import ConceptNoteBlock from "../_form-blocks/ConceptNoteBlock.js";
import ContractBlock from "../_form-blocks/ContractBlock.js";
import DescriptionBlock from "../_form-blocks/DescriptionBlock.js";
import ProposalBlock from "../_form-blocks/ProposalBlock.js";
import BudgetBlock from "../_form-blocks/BudgetBlock.js";
import DocumentsBlock from "../_form-blocks/DocumentsBlock.js";
import UsersBlock from "../_form-blocks/UsersBlock.js";
import DatesBlock from "../_form-blocks/DatesBlock.js";
import DonorsBlock from "../_form-blocks/DonorsBlock.js";
import PhotosBlock from "../_form-blocks/PhotosBlock.js";
import PurchasesBlock from "../_form-blocks/PurchasesBlock.js";
import MdSave from "react-icons/lib/md/save";

class EditProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      name: "",
      budget: "",
      description: "",
      documents_text: "",
      proposal: "",
      start_date: "",
      end_date: "",
      concept_note_text: "",
      contract_text: "",
      photos_text: "",
      purchases_text: "",
      rejected: false,
      photo: null,
      donors: [],
      users: [],
      navigationBlocked: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.validate = this.validate.bind(this);
    this.onPhotoUpload = this.onPhotoUpload.bind(this);
    this.onRejectedCheckboxClick = this.onRejectedCheckboxClick.bind(this);
  }

  /**
   * Change handler for inputs
   * @param {string} text
   * @param {string} name
   */
  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  /**
   * Changel handler for checkboxes
   * @param {any} value
   * @param {string} name
   */
  onCheckboxChange(value, name) {
    const arr = this.state[name];

    // check if state[name] has value
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
      this.setState({ [name]: arr });
    } else {
      this.setState({ [name]: arr.concat(value) });
    }
  }

  /**
   * click handler for reject checkbox
   * @param {any} value
   * @param {string} name
   */
  onRejectedCheckboxClick(value, name) {
    this.setState({ [name]: value });
  }

  /**
   * Handler for photo upload
   * @param {object} param0
   */
  onPhotoUpload({ file, range }) {
    this.setState({ photo: file, range });
  }

  /**
   * Validate input values
   */
  validate() {
    const checkAgainst = [
      "name",
      "description",
      "proposal",
      "budget",
      "documents_text",
      "start_date",
      "end_date"
    ];

    const errors = validate(this.state, checkAgainst);

    this.props.addErrors(errors);
    return Object.keys(errors).length === 0;
  }

  /**
   * Click handler for submit button
   * @param {object} e
   */
  onSubmitClick(e) {
    e.preventDefault();

    if (this.validate()) {
      // navigation is not blocked anymore
      this.setState({ navigationBlocked: false });

      const project = {
        id: this.state.id,
        name: this.state.name,
        budget: this.state.budget,
        description: this.state.description,
        documents_text: this.state.documents_text,
        photo: this.state.photo,
        proposal: this.state.proposal,
        start_date: this.state.start_date,
        end_date: this.state.end_date,
        donors: this.state.donors,
        concept_note_text: this.state.concept_note_text,
        contract_text: this.state.contract_text,
        photos_text: this.state.photos_text,
        purchases_text: this.state.purchases_text,
        attachments: this.props.attachments.map(a => a.id),
        users: this.state.users,
        assets: this.props.assets.filter(a => !a.id),
        rejected: this.state.rejected ? 1 : 0
      };

      this.props.emptyErrors();
      this.props.updateProject(project);
      alert("Project has been updated!");
    }
  }

  componentDidMount() {
    this.props.resetState();
    this.props.fetchDonors();
    this.props.fetchProject(this.props.match.params.id);
    this.props.fetchUsers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.attachments.length > 0) {
      this.setState({ navigationBlocked: true });
    }

    if (Object.keys(nextProps.project).length > 0) {
      this.setState({
        id: nextProps.project.id,
        name: nextProps.project.name,
        budget: nextProps.project.budget,
        description: nextProps.project.description,
        documents_text: nextProps.project.documents_text,
        proposal: nextProps.project.proposal,
        start_date: nextProps.project.start_date,
        end_date: nextProps.project.end_date,
        photo: nextProps.project.photo_url,
        concept_note_text: nextProps.project.concept_note_text,
        contract_text: nextProps.project.contract_text,
        photos_text: nextProps.project.photos_text,
        purchases_text: nextProps.project.purchases_text,
        donors: nextProps.project.donors.map(d => d.id),
        users: nextProps.project.users.map(u => u.id),
        rejected: !!nextProps.project.rejected
      });
    }
  }

  componentWillUnmount() {
    this.props.resetState();
    // Get attachments without project ids
    const unneededAttachments = this.props.attachments
      .filter(a => !a.project_id)
      .map(a => a.id);
    if (this.state.navigationBlocked && unneededAttachments.length > 0) {
      this.props.deleteAttachments(unneededAttachments);
      alert("You've navigated away. All changes destroyed!");
    }
  }

  render() {
    return (
      <div className="edit-project">
        <h2>Edit Project</h2>
        <Col _bottom-16>
          <Accordion>
            <div className="form-section expanded" title="General Info">
              <DescriptionBlock
                description={this.state.description}
                onChange={this.handleInputChange}
                onPhotoUpload={this.onPhotoUpload}
                projectName={this.state.name}
                photoUrl={this.state.photo}
              />
            </div>

            <div className="form-section expanded" title="Concept Note">
              <ConceptNoteBlock
                concept_note_text={this.state.concept_note_text}
                onChange={this.handleInputChange}
                isOptional={true}
              />
            </div>

            <div className="form-section expanded" title="Proposal">
              <ProposalBlock
                proposal={this.state.proposal}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-section expanded" title="Project Budget">
              <BudgetBlock
                budget={this.state.budget}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-section expanded" title="Contract">
              <ContractBlock
                contract_text={this.state.contract_text}
                onChange={this.handleInputChange}
                isOptional={true}
              />
            </div>

            <div className="form-section expanded" title="Donors">
              <DonorsBlock
                onCheckboxChange={this.onCheckboxChange}
                data={this.props.donors}
                checkAgainst={this.state.donors}
                isOptional={true}
              />
            </div>

            <div className="form-section expanded" title="Dates">
              <DatesBlock
                start_date={this.state.start_date}
                end_date={this.state.end_date}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-section expanded" title="Documents">
              <DocumentsBlock
                documents_text={this.state.documents_text}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-section expanded" title="Purchases">
              <PurchasesBlock
                purchases_text={this.state.purchases_text}
                onChange={this.handleInputChange}
                isOptional={true}
              />
            </div>

            <div className="form-section expanded" title="Photos">
              <PhotosBlock
                photos_text={this.state.photos_text}
                onChange={this.handleInputChange}
                isOptional={true}
              />
            </div>

            <div className="form-section expanded" title="Users">
              <UsersBlock
                onCheckboxChange={this.onCheckboxChange}
                data={this.props.users}
                checkAgainst={this.state.users}
              />
            </div>

            <div className="form-section expanded" title="Assets">
              <Assets />
            </div>
          </Accordion>

          <Checkbox
            text="This project is rejected"
            name="rejected"
            value={!this.state.rejected}
            checked={this.state.rejected}
            onCheckboxClick={this.onRejectedCheckboxClick}
          />

          <div>
            <Button
              className="btn-green space-between"
              onClick={this.onSubmitClick}
            >
              <MdSave />
              <span>Save</span>
            </Button>
          </div>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project.selected,
    users: state.user.allUsers,
    donors: state.donor.all,
    assets: state.asset.form,
    attachments: state.attachment.all
  };
};

const mapDispatchToProps = {
  addErrors: errors => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  resetState: () => dispatch => {
    dispatch(resetAssets());
    dispatch(resetAttachments());
    dispatch(unsetSelectedProject());
  },
  fetchUsers,
  deleteAttachments,
  fetchProject,
  fetchDonors,
  updateProject
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProject);



// WEBPACK FOOTER //
// ./src/components/main/projects/edit/EditProject.js